export default __webpack_public_path__ + "images/2ba592d2a9b7488ca8f2c23d555610ac-6_4K_1920x544.jpg";